import { useLogger } from '@booksy-com/vue-tools'
import { useApiClient } from '../client'

export const GET_BUSINESS_ENDPOINT = '/core/v2/business_api/me/businesses/{businessId}'

type GetBusinessResponse = {
  business?: { id?: unknown }
}

export function getBusiness (businessId, options = {}) {
  const defaults = {
    retries: 0,
    retryDelay: 1000, // miliseconds
  }

  const { retries, retryDelay } = Object.assign(defaults, options)

  const apiClient = useApiClient()
  let counter = retries + 1
  const logger = useLogger('api-getUserBusiness')

  const requestConfig = {
    url: GET_BUSINESS_ENDPOINT,
    urlParams: {
      businessId,
    },
  }

  const apiCall = async () => {
    try {
      counter--

      const response = await apiClient.get<GetBusinessResponse>(requestConfig)
      if (!response?.data?.business?.id) {
        logger.debug(`No business data, trying to fetch again counter:${counter}`)
        throw new Error('empty business data')
      }
      return response
    } catch (e) {
      if (counter > 0) {
        logger.debug(`${e} counter:${counter}`)
        // sleep
        await new Promise(resolve => setTimeout(resolve, retryDelay))
        return apiCall()
      } else {
        logger.debug(`Finally failed ${e}. Counter:${counter}`)
        throw e
      }
    }
  }

  return apiCall()
}
